import { render, staticRenderFns } from "./PopularServicesPage.vue?vue&type=template&id=4022b1d0"
import script from "./PopularServicesPage.vue?vue&type=script&lang=js"
export * from "./PopularServicesPage.vue?vue&type=script&lang=js"
import style0 from "./PopularServicesPage.vue?vue&type=style&index=0&id=4022b1d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports